import { FC, useState } from 'react';
import styled from 'styled-components';

import FiltersDropdown from '@/components/FilterDropdown';
import FilterButton from '@/components/FilterDropdown/FilterButton';
import FilterRadioButton from '@/components/FilterDropdown/FilterRadioButton';
import {
  FilterGroupBody,
  FilterGroupHeader,
  FilterGroupTitle,
  FilterWrap,
} from '@/components/FilterDropdown/Parts';

const StyledFilterWrap = styled(FilterWrap)`
  margin-left: auto;
  margin-right: 8px;
`;

interface Props {
  setCommentsFilter: React.Dispatch<React.SetStateAction<string>>;
  commentsFilter: string;
}

const CommentsFilter: FC<Props> = ({ commentsFilter, setCommentsFilter }) => {
  const [show, setShow] = useState(false);

  return (
    <StyledFilterWrap>
      <FilterButton
        text="Comment Replies"
        isActive={show}
        onClick={(e) => {
          e?.stopPropagation();
          setShow((prev) => !prev);
        }}
        filterApplied={!!commentsFilter}
        icon={
          <svg
            width="14"
            height="15"
            viewBox="0 0 14 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M3.4401 7.96847L0.942383 9.9774V1.94169C0.942383 1.80849 0.995568 1.68074 1.09024 1.58655C1.18491 1.49237 1.31331 1.43945 1.44719 1.43945H9.52411C9.658 1.43945 9.7864 1.49237 9.88107 1.58655C9.97574 1.68074 10.0289 1.80849 10.0289 1.94169V7.46624C10.0289 7.59944 9.97574 7.72718 9.88107 7.82137C9.7864 7.91556 9.658 7.96847 9.52411 7.96847H3.4401Z"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M3.97119 7.96875V10.4799C3.97119 10.6131 4.02438 10.7409 4.11905 10.835C4.21372 10.9292 4.34212 10.9821 4.476 10.9821H10.56L13.0577 12.9911V4.95536C13.0577 4.82216 13.0045 4.69441 12.9099 4.60023C12.8152 4.50604 12.6868 4.45312 12.5529 4.45312H10.0289"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        }
      />
      {show && (
        <FiltersDropdown onClose={() => setShow(false)}>
          <FilterGroupHeader>
            <FilterGroupTitle>Comment Replies</FilterGroupTitle>
          </FilterGroupHeader>
          <FilterGroupBody>
            <FilterRadioButton
              id={`comments-1`}
              value={''}
              checked={commentsFilter === ''}
              setValue={setCommentsFilter}
            >
              All
            </FilterRadioButton>
            <FilterRadioButton
              id={`comments-2`}
              value={'1'}
              checked={commentsFilter === '1'}
              setValue={setCommentsFilter}
            >
              Replied
            </FilterRadioButton>
            <FilterRadioButton
              id={`comments-3`}
              value={'0'}
              checked={commentsFilter === '0'}
              setValue={setCommentsFilter}
            >
              Unreplied
            </FilterRadioButton>
          </FilterGroupBody>
        </FiltersDropdown>
      )}
    </StyledFilterWrap>
  );
};

export default CommentsFilter;
